import axios from "axios";

import { store } from "../index";
import { toastr } from "react-redux-toastr";
import { setOptions } from "../actions/optionsActions";
import { apiCallCounterDec, apiCallCounterInc } from "../api/actions/index";
import { doLogout, getApiBaseURL, logout } from "../pushUpgrade/common";
import { PU_RELEATIVE_PATH } from "../config";
import { auth } from "../actions/authActions";

let domain = "";
let url = window.location.origin;
let apiBaseUrl = url && url.replace("/ui", "");

if (process.env.NODE_ENV === "production") {
  domain = "/coe";
} else {
  domain = "localhost:3000/";
  apiBaseUrl = "https://frameworkservices-azdev.congacloud.io/";
  // apiBaseUrl="https://frameworkservices-azqa.congacloud.io/";
  // apiBaseUrl="https://automationservices-canary.congacloud.io/";
}

export const readTextFile = function (file) {
  var rawFile = new XMLHttpRequest();
  rawFile.open("GET", "application.txt", false);
  rawFile.onreadystatechange = function () {
    if (rawFile.readyState === 4) {
      if (rawFile.status === 200 || rawFile.status == 0) {
        var allText = rawFile.responseText;
      }
    }
  };
  rawFile.send(null);
};

export const initOptions = function () {
  try {
    const options = require("../options.json");
    if (options) {
      store.dispatch(setOptions(options));
    }
  } catch (err) {
    // Do something for an error here
  }
};

let config = {
  baseURL: apiBaseUrl,
  timeout: 100000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    Pragma: "no-cache",
    // "Access-Control-Allow-Origin": "*",
    // "Access-Control-Allow-Headers": "X-Requested-With"
  },
  params: {},
};

export const setAuth = function (token) {
  if (token) {
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }
};

class Request {
  constructor() {
    this.baseURL = config.baseUrl;
    this.isRefreshing = false;
    this.failedRequests = [];
    this.client = axios.create({
      baseURL: config.apiServerBaseUrl,
      headers: {
        clientSecret: this.clientSecret,
      },
    });
    this.beforeRequest = this.beforeRequest.bind(this);
    this.onRequestFailure = this.onRequestFailure.bind(this);
    this.processQueue = this.processQueue.bind(this);
    this.client.interceptors.request.use(this.beforeRequest);
    this.client.interceptors.response.use(this.onRequestSuccess,
      this.onRequestFailure);
  }

  beforeRequest(config) {
    if (store.getState().auth.isAuthenticated) {
      config.headers.Authorization = store.getState().auth.token;
    }
    store.dispatch(apiCallCounterInc());
    return config;
  }

  onRequestSuccess(response) {
    store.dispatch(apiCallCounterDec());
    return response;
  }

  async onRequestFailure(err) {
    const { response } = err;
    if (response.status === 401 && err && err.config && !err.config.__isRetryRequest) {
      if (this.isRefreshing) {
        try {
          const token = await new Promise((resolve, reject) => {
            this.failedRequests.push({ resolve, reject });
          });
          err.config.headers.Authorization = `Bearer ${token}`;
          return this.client(err.config);
        }
        catch (e) {
          return e;
        }
      }
      this.isRefreshing = true;
      err.config.__isRetryRequest = true;
      return new Promise((resolve, reject) => {

        return this.client.post(getApiBaseURL() + "/ClientApplication/RefreshToken", {
          accessToken: localStorage.getItem("access_token"),
          refreshToken: localStorage.getItem("refresh_token")
        }).then((response) => response.data).then((response) => {
          this.isRefreshing = false;
          store.dispatch(auth({ ...store.getState().auth, token: `Bearer ${response.accessToken}` }));
          setAuth(response.accessToken);
          localStorage.setItem("access_token", response.accessToken);
          localStorage.setItem("refresh_token", response.refreshToken);

          this.processQueue(null, response.accessToken);
          resolve(this.client(err.config));
        }, (err) => {
          this.processQueue(err, null);
          reject(err.response);
          localStorage.clear();
          window.location.href = `${PU_RELEATIVE_PATH}welcome`;
        });
      });
    } else if (response.status === 403) {
      doLogout();
      let error_msg =
        "Insufficient Privileges  - You do not have the required access to perform the Operation. Please contact Conga Upgrade team or your Sys. Administrator";
      window.location.href =
        window.location.origin +
        "/registration/ui/forbidden?error=" +
        response.status +
        "&error_description=" +
        error_msg;
    } else if (response.status === 500) {
      console.log(response.statusText);
      throw Error(response.statusText);
    } else {
      console.log(response.statusText);
      throw Error(response.statusText);
    }
  }

  processQueue(error, token = null) {
    this.failedRequests.forEach((prom) => {
      if (error) {
        prom.reject(error);
      } else {
        prom.resolve(token);
      }
    });
    this.failedRequests = [];
  }

}

const request = new Request();

export default request.client;
